<template>
  <md-card-content>
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>請求書の送付方法</label>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-field>
          <label>{{ getBillViaName(form.bill_via) }}</label>
        </md-field>
      </div>
    </div>

    <!-- ご連絡先-->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>宛名</label>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>{{ form.name1 }}</label>
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>{{ form.name2 }}</label>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field>
          <label>{{ form.name3 }}</label>
        </md-field>
      </div>
    </div>

    <!-- 所在地-->
    <div class="md-layout md-gutter" v-if="isBillingWithFee()">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>所在地</label>
      </div>
      <div class="md-layout-item md-size-25 md-small-size-100">
        <md-field>
          <label>〒{{ postalCodeFormat(form.postal) }}</label>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="isBillingWithFee()">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field>
          <label>{{ form.pref }}{{ form.city }}{{ form.street_name }}</label>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field>
          <label>{{ form.street_number }}</label>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="isBillingWithFee()">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field>
          <label>{{ form.etc }}</label>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-50">
      </div>
    </div>

    <!-- メールアドレス-->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>メールアドレス</label></div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field>
          <label>{{ form.email }}</label>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
      </div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <div class="md-layout-item d-flex" v-for="(additionalAddressItem, index) in form.additionalAddresses"
             :key="'additionalAddresses_' + index">
          <div class="md-field d-block" style="padding-top: 0; margin: 0;">
            <md-field>
              <label>{{ additionalAddressItem }}</label>
            </md-field>
          </div>
        </div>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import Common      from "../../modules/common";
import CommonMixin from "../../mixins/commonMixin";

export default {
  name   : 'ContractPreviewSend',
  mixins : [CommonMixin],
  props  : ['form'],
  methods: {
    isBillingWithFee() {
      return this.form.bill_via !== Common.billingViaEmail;
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
